import React from 'react';
import AboutContent from './AboutContent';
import MainLayout from '../../layouts/MainLayout';

export default function About() {
  return (
    <MainLayout>
      <AboutContent />
    </MainLayout>
  );
}
